


































































import axios from "axios";
import Vue from "vue";
import { PaginatedResult, ScreenEvent, UserInfo } from "../../interfaces";
import { deleteEvent, getProfile } from "../../services";
import { canEditEvent } from "../../utils";
import CloneEvent from "./CloneEvent.vue";
import EventDetails from "./EventDetails.vue";

export default Vue.extend({
  components: {
    EventDetails,
    CloneEvent
  },
  data: () => ({
    headers: [
      {
        text: "Titel",
        value: "title",
        sortable: false
      },
      {
        text: "Raum",
        value: "room.title",
        sortable: false
      },
      {
        text: "Datum",
        value: "date"
      },
      {
        text: "Start",
        value: "tstart",
        sortable: false
      },
      {
        text: "Ende",
        value: "tend",
        sortable: false
      },
      {
        text: 'Abteilung',
        value: 'department.title',
        sortable: false
      },
      { text: "Aktionen", value: "actions", sortable: false },
    ],
    events: [] as any[],
    totalEvents: 20,
    options: { sortBy: ['date'], sortDesc: [true], page: 1, itemsPerPage: 10 },
    loading: true,
    eventType: "future" as 'future' | 'past',
    selectedOpen: false,
    selectedItem: {} as ScreenEvent,
    dialogDelete: false,
    dialogDetail: false,
    dialogClone: false,
    updatingOptions: false,
    userInfo: {} as UserInfo | undefined
  }),
  async created() {
    this.userInfo = await getProfile();
    await this.getEvents();
  },
  watch: {
    options: {
        async handler () {
          if (!this.updatingOptions) {
            await this.getEvents()
          }
        },
        deep: true,
      },
    eventType: async function() {
      this.updatingOptions = true;
      this.options.page = 1;
      this.options.sortDesc = [this.eventType === 'future' ? false : true];
      Vue.nextTick(()=>{
        this.updatingOptions = false
      });
      await this.getEvents();
    }
  },
  methods: {
    closeDelete() {
      this.selectedItem = {} as ScreenEvent;
      this.dialogDelete = false;
    },
    async closeDetail(shouldReload: boolean) {
      this.selectedItem = {} as ScreenEvent;
      this.dialogDetail = false;
      if (shouldReload) {
        await this.getEvents();
      }
    },
    async closeClone(shouldReload: boolean) {
      this.selectedItem = {} as ScreenEvent;
      this.dialogClone = false;
      if (shouldReload) {
        await this.getEvents();
      }
    },
    async createNewEvent() {
      this.selectedItem = {} as ScreenEvent;
      this.dialogClone = true;
    },
    showEvent(event: ScreenEvent) {
      this.selectedItem = Object.assign({}, event);
      this.dialogDetail = true;
    },
    cloneEvent(event?: ScreenEvent) {
      if (event) {
        this.selectedItem = Object.assign({}, event);
      } else {
        this.selectedItem = {} as ScreenEvent;
      }
      this.dialogClone = true;
    },
    deleteItem(item) {
      this.selectedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    async deleteItemConfirm() {
      await deleteEvent(this.selectedItem.id);
      this.selectedItem = {} as ScreenEvent;
      await this.getEvents();
      this.dialogDelete = false;
    },
    async getEvents() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options
      this.loading = true;
      const today = new Date().toISOString().substring(0, 10);
      const params = {} as any;
      if (this.eventType === 'future') {
        params.dstart = today;
      } else {
        params.dend = today;
      }
      params.page = page;
      params['page_size'] = itemsPerPage;
      if (sortDesc[0]) {
        params.sort = 'desc';
      } else {
        params.sort = 'asc';
      }
      const res = await axios.get<PaginatedResult<ScreenEvent>>(`/screen-events/api/events/`, {
        params,
      });
      this.events = res.data.results.map(e => ({...e, canEdit: canEditEvent(e, this.userInfo)}));
      this.totalEvents = res.data.count;
      this.loading = false;
    },
  },
});
